import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <section className="contact" id="main" role="main">
      <div className="container">
        <div className="section-header" style={{ marginBottom: 32 }}>
          <h1 style={{ color: "var(--primary-color)", marginBottom: 24 }}>
            Polityka Prywatności
          </h1>
          <p style={{ fontSize: "0.875rem", color: "var(--text-muted)" }}>
            Ostatnia aktualizacja: 10 sierpnia 2025
          </p>
        </div>

        <div
          className="contact-form"
          style={{ maxWidth: 900, margin: "0 auto", textAlign: "left" }}
        >
          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: "var(--primary-color)" }}>
              1. Informacje ogólne
            </h2>
            <p style={{ marginBottom: 16, lineHeight: 1.6 }}>
              Niniejsza Polityka Prywatności określa zasady przetwarzania i
              ochrony danych osobowych przekazywanych przez użytkowników w
              związku z korzystaniem ze strony internetowej
              <strong> jasnegranty.pl</strong> oraz usług świadczonych przez
              firmę Jasne Granty.
            </p>
            <p style={{ marginBottom: 16, lineHeight: 1.6 }}>
              Administratorem danych osobowych jest{" "}
              <strong>Jasne Granty</strong> z siedzibą w Warszawie, ul.
              Przykładowa 1, 00-001 Warszawa, adres e-mail:
              kontakt@jasnegranty.pl.
            </p>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: "var(--primary-color)" }}>
              2. Jakie dane zbieramy
            </h2>
            <p style={{ marginBottom: 16, lineHeight: 1.6 }}>
              W ramach świadczonych usług możemy przetwarzać następujące
              kategorie danych osobowych:
            </p>
            <ul style={{ marginBottom: 16, paddingLeft: 24 }}>
              <li style={{ marginBottom: 8 }}>
                <strong>Dane kontaktowe:</strong> imię, nazwisko, adres e-mail,
                numer telefonu, adres korespondencyjny
              </li>
              <li style={{ marginBottom: 8 }}>
                <strong>Dane organizacji:</strong> nazwa firmy/organizacji, NIP,
                REGON, KRS, adres siedziby
              </li>
              <li style={{ marginBottom: 8 }}>
                <strong>Dane projektowe:</strong> informacje o planowanych
                projektach, branży działania, potrzebach finansowych
              </li>
              <li style={{ marginBottom: 8 }}>
                <strong>Dane techniczne:</strong> adres IP, informacje o
                przeglądarce, pliki cookies
              </li>
              <li style={{ marginBottom: 8 }}>
                <strong>Dane komunikacji:</strong> treść korespondencji e-mail,
                rozmów telefonicznych, wiadomości z formularza kontaktowego
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: "var(--primary-color)" }}>
              3. Cele i podstawy prawne przetwarzania
            </h2>
            <div style={{ marginBottom: 16 }}>
              <h3
                style={{
                  fontSize: "1.125rem",
                  marginBottom: 12,
                  color: "var(--primary-color)",
                }}
              >
                3.1 Wykonanie umowy lub działania przedumowne
              </h3>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                Przetwarzamy dane w celu:
              </p>
              <ul style={{ marginBottom: 16, paddingLeft: 24 }}>
                <li>Przygotowania oferty usług doradczych</li>
                <li>
                  Realizacji umów o świadczenie usług (pisanie wniosków,
                  doradztwo, szkolenia)
                </li>
                <li>Komunikacji związanej z realizacją projektów</li>
                <li>Rozliczenia świadczonych usług</li>
              </ul>
            </div>

            <div style={{ marginBottom: 16 }}>
              <h3
                style={{
                  fontSize: "1.125rem",
                  marginBottom: 12,
                  color: "var(--primary-color)",
                }}
              >
                3.2 Uzasadniony interes administratora
              </h3>
              <ul style={{ marginBottom: 16, paddingLeft: 24 }}>
                <li>Marketing bezpośredni usług</li>
                <li>Analiza skuteczności działań marketingowych</li>
                <li>Dochodzenie roszczeń i obrona przed roszczeniami</li>
                <li>Archiwizacja dokumentacji</li>
              </ul>
            </div>

            <div style={{ marginBottom: 16 }}>
              <h3
                style={{
                  fontSize: "1.125rem",
                  marginBottom: 12,
                  color: "var(--primary-color)",
                }}
              >
                3.3 Zgoda
              </h3>
              <ul style={{ marginBottom: 16, paddingLeft: 24 }}>
                <li>
                  Wysyłanie newslettera z informacjami o nowych programach
                  grantowych
                </li>
                <li>Profilowanie w celach marketingowych</li>
                <li>
                  Wykorzystanie danych do case studies (w formie
                  zanonimizowanej)
                </li>
              </ul>
            </div>

            <div>
              <h3
                style={{
                  fontSize: "1.125rem",
                  marginBottom: 12,
                  color: "var(--primary-color)",
                }}
              >
                3.4 Obowiązek prawny
              </h3>
              <ul style={{ paddingLeft: 24 }}>
                <li>Prowadzenie dokumentacji podatkowej i księgowej</li>
                <li>Archiwizacja zgodnie z przepisami prawa</li>
              </ul>
            </div>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: "var(--primary-color)" }}>
              4. Okres przechowywania danych
            </h2>
            <ul style={{ paddingLeft: 24 }}>
              <li style={{ marginBottom: 8 }}>
                <strong>Dane klientów:</strong> przez okres trwania umowy i
                dodatkowo przez 6 lat po jej zakończeniu
              </li>
              <li style={{ marginBottom: 8 }}>
                <strong>Dane kontaktowe potencjalnych klientów:</strong> do
                momentu wycofania zgody lub przez 3 lata od ostatniego kontaktu
              </li>
              <li style={{ marginBottom: 8 }}>
                <strong>Dane z formularzy kontaktowych:</strong> przez 2 lata od
                wysłania
              </li>
              <li style={{ marginBottom: 8 }}>
                <strong>Newsletter:</strong> do momentu rezygnacji z subskrypcji
              </li>
              <li style={{ marginBottom: 8 }}>
                <strong>Pliki cookies:</strong> zgodnie z ustawieniami
                przeglądarki, maksymalnie 24 miesiące
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: "var(--primary-color)" }}>
              5. Udostępnianie danych
            </h2>
            <p style={{ marginBottom: 16, lineHeight: 1.6 }}>
              Dane osobowe mogą być udostępniane:
            </p>
            <ul style={{ paddingLeft: 24 }}>
              <li style={{ marginBottom: 8 }}>
                <strong>Podwykonawcom:</strong> którzy wspierają nas w
                realizacji projektów (eksperci branżowi, tłumacze)
              </li>
              <li style={{ marginBottom: 8 }}>
                <strong>Dostawcom usług IT:</strong> hosting, systemy CRM,
                narzędzia do komunikacji
              </li>
              <li style={{ marginBottom: 8 }}>
                <strong>Instytucjom grantodawczym:</strong> w przypadkach
                wymaganych przez regulaminy konkursów
              </li>
              <li style={{ marginBottom: 8 }}>
                <strong>Organom publicznym:</strong> w przypadkach określonych
                przez prawo
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: "var(--primary-color)" }}>
              6. Twoje prawa
            </h2>
            <p style={{ marginBottom: 16, lineHeight: 1.6 }}>Masz prawo do:</p>
            <ul style={{ paddingLeft: 24 }}>
              <li style={{ marginBottom: 8 }}>
                Dostępu do swoich danych osobowych
              </li>
              <li style={{ marginBottom: 8 }}>
                Sprostowania nieprawidłowych danych
              </li>
              <li style={{ marginBottom: 8 }}>
                Usunięcia danych (prawo do bycia zapomnianym)
              </li>
              <li style={{ marginBottom: 8 }}>Ograniczenia przetwarzania</li>
              <li style={{ marginBottom: 8 }}>Przenoszenia danych</li>
              <li style={{ marginBottom: 8 }}>Sprzeciwu wobec przetwarzania</li>
              <li style={{ marginBottom: 8 }}>
                Cofnięcia zgody w dowolnym momencie
              </li>
              <li style={{ marginBottom: 8 }}>
                Wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych
              </li>
            </ul>
            <p style={{ marginBottom: 16, lineHeight: 1.6 }}>
              W celu realizacji swoich praw skontaktuj się z nami:
              <a
                href="mailto:kontakt@jasnegranty.pl"
                style={{ color: "var(--secondary-color)" }}
              >
                kontakt@jasnegranty.pl
              </a>
            </p>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: "var(--primary-color)" }}>
              7. Cookies i technologie śledzące
            </h2>
            <p style={{ marginBottom: 16, lineHeight: 1.6 }}>
              Nasza strona wykorzystuje pliki cookies w celu:
            </p>
            <ul style={{ marginBottom: 16, paddingLeft: 24 }}>
              <li style={{ marginBottom: 8 }}>
                Zapewnienia prawidłowego funkcjonowania strony
              </li>
              <li style={{ marginBottom: 8 }}>
                Analizy ruchu i zachowań użytkowników (Google Analytics)
              </li>
              <li style={{ marginBottom: 8 }}>Personalizacji treści</li>
              <li style={{ marginBottom: 8 }}>Remarketing marketingowego</li>
            </ul>
            <p style={{ marginBottom: 16, lineHeight: 1.6 }}>
              Możesz zarządzać ustawieniami cookies w swojej przeglądarce.
              Wyłączenie niektórych plików cookies może wpłynąć na
              funkcjonalność strony.
            </p>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: "var(--primary-color)" }}>
              8. Bezpieczeństwo danych
            </h2>
            <p style={{ marginBottom: 16, lineHeight: 1.6 }}>
              Stosujemy odpowiednie środki techniczne i organizacyjne w celu
              ochrony danych osobowych:
            </p>
            <ul style={{ paddingLeft: 24 }}>
              <li style={{ marginBottom: 8 }}>
                Szyfrowanie połączeń (protokół HTTPS)
              </li>
              <li style={{ marginBottom: 8 }}>Regularne kopie zapasowe</li>
              <li style={{ marginBottom: 8 }}>
                Ograniczony dostęp do danych - tylko upoważniony personel
              </li>
              <li style={{ marginBottom: 8 }}>
                Szkolenia zespołu z zakresu ochrony danych
              </li>
              <li style={{ marginBottom: 8 }}>
                Umowy powierzenia z podwykonawcami
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: "var(--primary-color)" }}>
              9. Zmiany w Polityce Prywatności
            </h2>
            <p style={{ marginBottom: 16, lineHeight: 1.6 }}>
              Zastrzegamy sobie prawo do wprowadzania zmian w niniejszej
              Polityce Prywatności. O istotnych zmianach będziemy informować
              poprzez komunikat na stronie internetowej.
            </p>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: "var(--primary-color)" }}>
              10. Kontakt
            </h2>
            <p style={{ marginBottom: 16, lineHeight: 1.6 }}>
              W przypadku pytań dotyczących ochrony danych osobowych, skontaktuj
              się z nami:
            </p>
            <div
              style={{
                background: "var(--background-color)",
                padding: 20,
                borderRadius: 8,
                border: "1px solid var(--border-color)",
              }}
            >
              <p style={{ margin: 0, lineHeight: 1.8 }}>
                <strong>Jasne Granty</strong>
                E-mail:{" "}
                <a
                  href="mailto:kontakt@jasnegranty.pl"
                  style={{ color: "var(--secondary-color)" }}
                >
                  kontakt@jasnegranty.pl
                </a>
              </p>
            </div>
          </section>

          <div
            style={{
              display: "flex",
              gap: 12,
              flexWrap: "wrap",
              marginTop: 40,
            }}
          >
            <Link to="/" className="btn btn-primary">
              Strona główna
            </Link>
            <Link to="/blog" className="btn btn-outline">
              Blog
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
